import { animate, style, transition, trigger } from '@angular/animations';
import { Component, HostBinding, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs';
import { NavMenuService } from '../nav-menu.service';

@Component({
  selector: 'cs-to-do',
  standalone: false,
  templateUrl: './to-do.component.html',
  styleUrls: ['./to-do.component.scss'],
  animations: [
    trigger('notifyLeave', [
      transition(':leave', [
        style({ opacity: 1 }),
        animate('1s ease-in-out', style({ opacity: 0 }))
      ])
    ])
  ]
})
export class ToDoComponent implements OnInit, OnDestroy {
  private $onDestroy = new Subject();
  @HostBinding('class.cs-nav-drop-down-opened')
  public displayDropDown = false;
  public vieMoreLink: Array<string> = ['crm/customers/discount-requests'];

  constructor(private navMenuService: NavMenuService) {}

  public ngOnInit(): void {
    this.navMenuService.$openedDropDown
      .pipe(takeUntil(this.$onDestroy))
      .subscribe(val => {
        if (this !== val) {
          this.backDropClick();
        }
      });
  }

  public ngOnDestroy(): void {
    this.$onDestroy.next(0);
    this.$onDestroy.complete();
  }

  public backDropClick(): void {
    this.displayDropDown = false;
  }

  public stopPropagation(event: Event): void {
    event.stopPropagation();
  }

  public openDropDown(): void {
    if (!this.displayDropDown) {
      this.navMenuService.$openedDropDown.next(this);
      this.displayDropDown = true;
    }
  }

  public activeTab(i: number): void {
    switch (i) {
      case 0:
        this.vieMoreLink = ['crm/customers/discount-requests'];
        break;
      case 1:
        this.vieMoreLink = ['crm/customers/kyc-documents'];
        break;
      case 2:
        this.vieMoreLink = ['crm/customer-payments/requests'];
        break;
      case 3:
        this.vieMoreLink = ['crm/customers/cancel-requests'];
        break;
      case 4:
        this.vieMoreLink = ['crm/customers/unit-change-requests'];
        break;
      case 5:
        this.vieMoreLink = ['sales/lead-requests'];
        break;
      case 6:
        this.vieMoreLink = ['crm/customers/applicant-change-requests'];
        break;
      case 7:
        this.vieMoreLink = ['crm/customers/unit-customization-approval'];
        break;
      case 8:
        this.vieMoreLink = ['crm/customers/commission-approval'];
        break;
      case 9:
        this.vieMoreLink = ['crm/customers/milestone-approval'];
        break;
      case 10:
        this.vieMoreLink = ['crm/customers/tds-approval'];
        break;
      case 12:
        this.vieMoreLink = ['site/dms/document-requests'];
    }
  }
}
